<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{ 'Status' | translate }}</h5>
    <button tabindex="10" type="button" class="close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label>{{ 'Currently I am' | translate }}</label>
      <select class="form-control" [ngModel]="profileStatus().profileType" (ngModelChange)="updateField('profileType', $event)">
        <option *ngFor="let option of profileTypes; trackBy: trackByValue" [ngValue]="option.value">
          {{ option.name | translate }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label>{{ 'Currently I am looking for' | translate }}</label>
      <select class="form-control" [ngModel]="profileStatus().lookingFor" (ngModelChange)="updateField('lookingFor', $event)">
        <option *ngFor="let option of lookingForOptions; trackBy: trackByValue" [ngValue]="option.value">
          {{ option.name | translate }}
        </option>
      </select>
    </div>
  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
        {{ 'Back' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="save()">
        {{ 'Save' | translate }}
      </button>
    </div>
  </div>
</div>
